export default "__VITE_ASSET__DB7z6Ze0__"